/**
 * @Author: Zewei
 * @Date:   2018-01-22T09:58:52+08:00
 * @Last modified by:
 * @Last modified time: 2018-02-28T13:05:40+08:00
 */

import keyMirror from "keymirror";

export const UserConstants = {
 ActionTypes: keyMirror({
    CHANGESUBMITTING: null,
    LOGINSUCCESS: null,
    LOGINFAILURE: null,
    LOGOUTSUCCESS: null,
    LOGOUTFAILURE: null,
    FETCHUSERSUCCESS: null,
    FETCHAUTHSUCCESS: null,
    FETCHAUTHFAILURE: null,
    FETCHUSERAUTHSUCCESS:null,
    FETCHUSERMOBILEAUTHSUCCESS:null,
  })
};



// WEBPACK FOOTER //
// ./src/constants/user-constants.js